/**
 * The colour of the agent whose cursor targets a frame, for the agent ring
 * on the frame's window and on its wall card or Pinned tile (Part 06 Q4).
 * Focus shows no ring: the cursor works over the focused window itself.
 */
import { useCallback, type CSSProperties } from "react";
import { useCanvasStore } from "@/stores/canvas-store";
import { usePresentationStore } from "@/stores/presentation-store";
import "./streaming-effects.css";

/** Pulses with `agent-target-ring` (streaming-effects.css). */
export const AGENT_TARGET_RING_CLASS = "agent-target-ring";

export function useFrameTargetingColor(frameId: string): string | null {
  const inFocus = usePresentationStore(
    (s) => s.presentation?.variant === "focus",
  );
  return useCanvasStore(
    useCallback(
      (s) => {
        if (inFocus) return null;
        for (const cursor of s.agentCursors.values()) {
          if (cursor.targetFrameId === frameId) return cursor.color;
        }
        return null;
      },
      [inFocus, frameId],
    ),
  );
}

/** The ring's glow and border in the agent's colour. */
export function agentTargetRingStyle(color: string): CSSProperties {
  return {
    boxShadow: `0 0 12px 2px ${color}40, inset 0 0 12px 2px ${color}20`,
    border: `1.5px solid ${color}60`,
  };
}
